import { useRouter } from 'next/router';
import { type RpcLimitOrder } from '@/shared/utils/orders';
import { useCloseLimitOrder } from '../../hooks/useCloseLimitOrder';
import { OrdersTableDropdown } from '../Orders/OrdersTableDropdown';

export const LimitOrderAdditionalCell = ({ order }: { order: RpcLimitOrder }) => {
  const router = useRouter();
  const { mutate: closeLimitOrder } = useCloseLimitOrder(order);

  return (
    <OrdersTableDropdown
      onRedirect={() =>
        router.push(new URL(`/pools/${order.asset}`, process.env.NEXT_PUBLIC_EXPLORER_URL))
      }
      onClose={closeLimitOrder}
    />
  );
};
